import { type InsuranceAvatarProps } from "./types";

export function InsuranceAvatar({
  identity,
  className = "",
  size = "md",
  showBackground = false,
}: InsuranceAvatarProps) {
  const sizeClasses = {
    xs: "w-5 h-5",
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  const LogoComponent = identity.logo;
  const BackgroundComponent = identity.background;

  if (!showBackground) {
    return (
      <div className={`${sizeClasses[size]} shrink-0 ${className}`}>
        <LogoComponent className="w-full h-full" />
      </div>
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} shrink-0 relative overflow-hidden rounded-lg ${className}`}
      style={{ backgroundColor: identity.backgroundColor }}
    >
      {/* Background SVG layer (if available) */}
      {BackgroundComponent && (
        <div className="absolute inset-0">
          <BackgroundComponent className="w-full h-full" />
        </div>
      )}
      {/* Logo layer */}
      <div className="relative z-10 w-full h-full">
        <LogoComponent className="w-full h-full" />
      </div>
    </div>
  );
}
